<template>
<b-overlay :show="loading" rounded="sm">
  <b-card>
    <b-card-title
      class="fs-32 d-flex align-items-center justify-content-between"
    >
      <div class="d-flex align-items-center">
        <span>Carteira dos clientes</span>
      </div>
    </b-card-title>
    <div>
      <span>Abaixo os clientes que tem a opção de marcar suas compras</span>
    </div> 

    <div class="mt-3 mb-5">
      <b-button 
        class="mr-3" 
        variant="danger"
        @click="$refs.videoManual.toggleOpen({ 
          url: 'https://www.youtube.com/watch?v=8mNLjdDFcSg&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=4', 
          title: 'Carteira dos clientes' 
        })"
      >
        <i class="fas fa-play mr-1"></i>
        Ver video
      </b-button>
      <a class="btn btn-success" href="https://api.construp.com.br/assets/Carteira de clientes.pdf" target="_blank" download><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a>
    </div>

    <b-card-text>
      <div class="mt-2 d-flex justify-content-end">
        <button 
          class="mt-1 btn btn-success"
          @click="$refs.newClient.toggleOpen(data)"
        >Adicionar cliente</button>
      </div>
      
      
      <b-row class="mt-3">
        <b-col cols="12">
          <input
            type="text"
            v-model="filterClient"
            @keyup.enter="getAll()"
            class="form-control"
            placeholder="Pesquise por nome do cliente"
          />
        </b-col>
        
        <b-col cols="12" class="mt-2">
          <button 
            class="btn btn-success" 
            v-b-tooltip.hover 
            @click="getAll()"
          >
            <i class="fas fa-search mr-2"></i>
            Pesquisar
          </button>
          
          <button 
            class="btn btn-warning ml-4" 
            title="Limpar pesquisa" 
            v-b-tooltip.hover 
            @click="cleanSearch()"
          >
            <i class="fa fa-trash mr-2"></i>
            Limpar pesquisa
          </button>
        </b-col>
      </b-row>
       
      <div class="row">
        <div class="mt-3 col">
          <span class="ml-2 fs-18">{{ pagination.total }} Clientes encontrados</span>
          <b-table
            class="mt-3"
            striped
            hover
            responsive
            :fields="headers"
            :items="data"
            :busy="loading"
            show-empty
            empty-text="Nenhum cliente encontrado"
          >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>Carregando...</strong>
              </div>
            </template>
          
            <template #cell(block)="data">
              <span v-if="data.item.block == 0">Não</span> 
              <span v-else class="text-danger">Sim</span> 
            </template>

            <template #cell(nameClient)="data">
              <span :class="data.item.block == 1 ? 'text-danger' : ''">{{ clientName(data.item) }}</span>
            </template>

            <template #cell(type)="data">
              <span :class="data.item.block == 1 ? 'text-danger' : ''">{{ typeClient(data.item) }}</span>
            </template>

            <template #cell(limit)="data">
              <span :class="data.item.block == 1 ? 'text-danger' : ''">R$ {{ formatMoneyUn(data.item.limit) }}</span>
            </template>

            <template #cell(spent)="data">
              <span :class="data.item.block == 1 ? 'text-danger' : ''">R$ {{ formatMoneyUn(data.item.spent) }}</span>
            </template>

            <template #cell(balance)="data">
              <span :class="data.item.block == 1 ? 'text-danger' : ''">R$ {{ formatMoneyUn(data.item.balance) }}</span>
            </template>

            <template #cell(due)="data">
              <span :class="data.item.block == 1 ? 'text-danger' : ''">{{ data.item.due }}</span>
            </template>

            <template #cell(action)="data">
              <b-row no-gutters class="justify-content-md-center text-center">
                <b-col class="mb-2">
                  <span 
                    @click="$refs.editClient.toggleOpen(data.item)"
                    class="btn btn-outline-primary fs-20"
                    v-b-tooltip.hover
                    data-placement="top" 
                    title="Editar"
                  >
                    <i class="fa fa-pen"></i>
                  </span>
                </b-col>

                <b-col class="mb-2">
                  <span
                    @click="showModal('payment', data.item)"
                    class="btn btn-outline-success fs-20"
                    v-b-tooltip.hover
                    data-placement="top"
                    title="Receber pagamento"
                  >
                    <i class="fa fa-money-bill"></i>
                  </span>
                </b-col>
                
                <b-col class="mb-2">
                  <span
                    @click="$refs.deleteClient.toggleOpen(data.item)"
                    class="btn btn-outline-danger fs-20"
                    v-b-tooltip.hover
                    data-placement="top"
                    title="Excluir"
                  >
                    <i class="fa fa-trash"></i>
                  </span>
                </b-col> 

                <b-col class="mb-2">
                  <span
                    v-if="data.item.block == 0"
                    @click="$refs.blockClient.toggleOpen(data.item)"
                    class="btn btn-outline-warning fs-20"
                    data-placement="top"
                    title="Bloquear"
                    v-b-tooltip.hover
                  >
                    <i class="fa fa-lock"></i>
                  </span>
                  <span
                    v-else
                    @click="$refs.unlockClient.toggleOpen(data.item)"
                    class="btn btn-outline-info fs-20"
                    v-b-tooltip.hover
                    data-placement="top" 
                    title="Desbloquear"
                  >
                    <i class="fa fa-unlock"></i>
                  </span>
                </b-col>
                
                <b-col class="mb-2">
                  <span
                    @click="$refs.detailsClient.toggleOpen({user: data.item})"
                    class="btn btn-outline-primary fs-20"
                    v-b-tooltip.hover
                    data-placement="top"
                    title="Detalhes cliente"
                  >
                    <i class="fa fa-user"></i>
                  </span>
                </b-col>
              </b-row>      
            </template>
          </b-table>
        </div> 
        
        <b-col cols="12" class="d-flex align-items-center justify-content-center">
          <b-pagination
            v-model="pagination.currentPage"
            :total-rows="pagination.total"
            :per-page="pagination.itemsPerPage"
            :disabled="loading"
          ></b-pagination>
        </b-col>

      </div>
    </b-card-text>
    <div>
      <!-- MODAL PAGAMENTO-->
      <b-modal ref="payment" size="lg" no-close-on-backdrop centered hide-footer title="Recebimento do pagamento">
        <div class="d-block text-center mb-4">
          <h4>Digite abaixo o valor a receber do Cliente</h4>
          <h5 
            class="text-danger mt-4 mb-3"
            v-if="dataEdit.block == 1"  
          >
          Esse usuário esta bloqueado no momento
        </h5>
          <h5 class="mt-3 text-secondary">{{dataEdit.first_name}} {{dataEdit.last_name}}</h5>
        </div>
        <div class="row">
          <b-col cols="6" lg="3" class="mb-3">
            <label>Crédito do cliente</label>
            <div class="input-group mb-3">
              <div class="input-group-append">
                <span class="input-group-text" id="value-total">R$</span>
              </div>
              <input v-model="dataEdit.limit" type="number" class="form-control" disabled>
            </div>
          </b-col>         
          <b-col cols="6" lg="3" class="mb-3">
            <label>Valor em aberto</label>
            <div class="input-group mb-3">
              <div class="input-group-append">
                <span class="input-group-text">R$</span>
              </div>
              <input v-model="dataEdit.spent" type="number" class="form-control"  disabled>
            </div>
          </b-col>
          <b-col cols="6" lg="3" class="mb-3">
            <label>Limite disponível</label>
            <div class="input-group mb-3">
              <div class="input-group-append">
                <span class="input-group-text">R$</span>
              </div>
              <input v-model="dataEdit.balance" type="number" class="form-control" disabled>
            </div>
          </b-col>
          <b-col cols="6" lg="3" class="mb-3">
            <label>Dia vencimento</label>
            <input v-model="dataEdit.due" type="number" class="form-control" disabled>
          </b-col>
        </div>
        <div class="row">
          <b-col cols="6" lg="3" class="mb-3">
            <label>Valor a receber</label>
            <div class="input-group mb-3">
              <div class="input-group-append">
                <span class="input-group-text">R$</span>
              </div>
              <input 
                :disabled="dataEdit.spent == 0"
                v-model="dataEdit.value" 
                type="text" 
                class="form-control" 
                placeholder="digite o valor"
                v-mask="['#,##','##,##','###,##','####,##','#####,##', '######,##']"
              >
            </div>
          </b-col>
          <b-col cols="6" class="mb-3">
            <label>Forma de pagamento</label>
              <input 
                v-model="dataEdit.form" 
                type="text" 
                class="form-control" 
                placeholder="digite a forma de pagamento"
              >
          </b-col>
          <b-col cols="12" lg="3" class="mb-3">
            <label>Novo saldo após pagamento</label>
            <div class="input-group mb-3">
              <div class="input-group-append">
                <span class="input-group-text">R$</span>
              </div>
              <input 
                v-model="newBalance" 
                type="text" 
                class="form-control" 
                disabled
                v-mask="['#,##','##,##','###,##','####,##','#####,##', '######,##']"
              >
            </div>
          </b-col>
        </div>
        <div class="end">
          <button class="mt-3 btn btn-success" @click="savePayment">Receber</button>
          <button class="mt-3 btn btn-danger ml-3" @click="hideModal('payment')">Fechar</button>
        </div>
        <div class="d-block text-center mb-4 mt-3">
          <h4>Histórico dos últimos 15 pagamentos</h4>
        </div>
        
        <!-- historico...ultimos 15 -->
        <table class="table">  
          <thead>
            <tr>
              <th scope="col">Data de pagamento </th>
              <th scope="col">Valor Pago</th>
              <th scope="col">Forma de pagamento </th>
            </tr>
          </thead>
          <tbody v-for="(history, index) in historyPayment" :key="index">
            <tr>
              <td>{{ history.date }}</td>
              <td>R$ {{ formatMoneyUn(history.payment_value) }}</td>
              <td>{{ history.form_payment }}</td>
            </tr>
          </tbody>
        </table>      
      </b-modal>

      <DetailsClient 
        ref="detailsClient"
      />

      <NewClient 
        ref="newClient"
        @getAllClient="getAll()"
      />

      <EditValue 
        ref="editClient"
        @getAllClient="getAll()"
      />

      <DeleteClient 
        ref="deleteClient"
        @getAllClient="getAll()"
      />

      <UnlockClient 
        ref="unlockClient"
        @getAllClient="getAll()"
      />
      
      <BlockClient 
        ref="blockClient"
        @getAllClient="getAll()"
      />
      
      <VideoManual ref="videoManual"/>
    </div>
  </b-card>
</b-overlay>
</template>

<script>
import makeToast from '../../../mixins/makeToast';
import {mapActions, mapState } from 'vuex';
import DetailsClient from 'Components/Wallet/DetailsClient.vue';
import NewClient from 'Components/Wallet/NewClient.vue';
import EditValue from 'Components/Wallet/EditValue.vue';
import DeleteClient from 'Components/Wallet/DeleteClient.vue';
import UnlockClient from 'Components/Wallet/UnlockClient.vue';
import BlockClient from 'Components/Wallet/BlockClient.vue';
import VideoManual from '@/components/VideoManual.vue';

export default {
  name: 'WalletApp',
  mixins: [makeToast],
  
  components: {
    DetailsClient,
    NewClient,
    EditValue,
    DeleteClient,
    UnlockClient,
    BlockClient,
    VideoManual
  },
  
  data() {
    return {
      loading: false,
      data: [],
      headers: [
        {
          key: 'block',
          label: 'Bloqueado',
          sortable: false,
        },
        {
          key: 'nameClient',
          label: 'Cliente',
          sortable: false,
        },
        {
          key: 'type',
          label: 'Tipo',
          sortable: false,
          headerClass: "d-none d-md-table-cell", 
          tdClass: "d-none d-md-table-cell",
          thClass: "d-none d-md-table-cell" 
        },
        {
          key: 'limit',
          label: 'Total',
          sortable: false,
          headerClass: "d-none d-md-table-cell", 
          tdClass: "d-none d-md-table-cell",
          thClass: "d-none d-md-table-cell" 
        },
        {
          key: 'spent',
          label: 'Usado',
          sortable: false,
          headerClass: "d-none d-md-table-cell", 
          tdClass: "d-none d-md-table-cell",
          thClass: "d-none d-md-table-cell" 
        },
        {
          key: 'balance',
          label: 'Saldo',
          sortable: false,
        },
        {
          key: 'due',
          label: 'Venc.',
          sortable: false,
          headerClass: "d-none d-md-table-cell", 
          tdClass: "d-none d-md-table-cell",
          thClass: "d-none d-md-table-cell" 
        },
        {
          key: 'action',
          label: 'Ações',
          sortable: false,
          tdStyle: 'width: 300px;',
        },
      ],

      dataEdit: {
        limit: 0,
        spent: 0,
        user_id: '',
        balance: 0,
        block: '',
        due: '',
        value: 0,
        form: '',
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 15,
        total: 0,
      },
      due: '',
      newBalance:'',
      historyPayment:'',
      limit:'',
      cpf:'',
      client:[],
      selected: '',
      selectedClient: '',
      day: [],
      filterClient: '',
      first_name: '',
      last_name: '',
      newConstrup_user_id:'',
      newUser_id: '',
      newLimit:'',
      newDue: '',
      newBlock: 0
    };
  },

  mounted() {
   this.getAll();
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },
  
  watch:{
    'dataEdit.value': function(){
      let newValue = this.dataEdit.value.replace(",", ".")
      if(parseFloat(newValue)<= this.dataEdit.spent){
        this.newBalance = (this.dataEdit.balance + parseFloat(newValue))*100;
      }else{
        this.dataEdit.value = this.dataEdit.spent;
      }
    },

    'pagination.currentPage': function () {
        this.getAll();
      },
  },
  
  methods: {
    ...mapActions('shopkeeper', [
      'allWallet',
      'paymentWallet',
      'historyPaymentWalletShopkeeper'
    ]),

    typeClient(data){
      if(data.client) return 'Cliente';
      if(data.professional) return 'Profissional';
      if(data.company) return 'Empresa';
    },

    clientName(data){
      if(data.client) return data.client.first_name +" "+data.client.last_name;
      if(data.professional){
        if(data.professional.name) return data.professional.name;
        if(data.professional.fantasy_name) return data.professional.fantasy_name;
        if(data.professional.company_name) return data.professional.company_name;
      } 
      if(data.company){
        if(data.company.nome_fantasia) return data.company.nome_fantasia;
        if(data.company.razao_social) return data.company.razao_social;
      } 
    },

    cleanSearch(){
      this.filterClient = '';
      this.pagination.currentPage = 1;
      this.getAll();
    },

    formatDate(){
      let index = 0;
      this.historyPayment.forEach(element => {
        let newData = element.date.slice(0,-9);
        let split = newData.split('-');
        this.historyPayment[index].date = split[2]+'/'+split[1]+'/'+split[0]
        index ++
      })
    },

    getAll(){
      this.$store.dispatch('startLoader');
      this.allWallet({
        construpUserId: this.dadosUsuario.id,
        currentPage: this.pagination.currentPage,
        name: this.filterClient
      })
      .then((response) => {
        this.data = response.data.data.data ? response.data.data.data : response.data.data;
        this.pagination.total = response.data.data.total ? response.data.data.total : 0; 
      })
      .catch(() => {
        this.makeToast(
          'Erro',
          'Houve um erro ao trazer os dados, favor atualizar a pagina',
          'danger'
        );
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },

    formatMoneyUn(value) {
      var money = parseFloat(value);
      return money.toLocaleString('pt-br', {minimumFractionDigits: 2});
    },

    showModal(value, data) {
      if(value == "payment"){
        this.dataEdit = data;
        const users = {
          'construpUserId': data.construp_user_id, 
          'idUser': data.user_id
        }
        this.$store.dispatch('startLoader');
        this.historyPaymentWalletShopkeeper(users)
        .then((response) => {
          this.historyPayment = response.data.data;
          this.formatDate();
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os dados, favor atualizar a pagina',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
      }

      this.$refs[value].show()
    },
    
    hideModal(value) {
      this.dataEdit = ''
      this.$refs[value].hide();
    },

    savePayment(){   
      let value = this.dataEdit.value.replaceAll(',','');
      this.dataEdit.value = value/100;
      const data = {
        payment_value: this.dataEdit.value ,
        form_payment: this.dataEdit.form ,
        id:this.dataEdit.id,
        limit: this.dataEdit.limit,
        due: this.dataEdit.due,
        construp_user_id: this.dataEdit.construp_user_id,
        spent: this.dataEdit.spent
      }

      if(data.payment_value <=0 || data.payment_value == '' || data.payment_value == null || data.payment_value == undefined ){
        this.makeToast(
          'Erro',
          'Pagamento não pode ser menor ou igual a 0 ou vazio',
          'danger'
        );
        return;
      }
      
      if(data.form_payment == '' || data.form_payment == null || data.form_payment == undefined ){
        this.makeToast(
          'Erro',
          'Favor digitar a forma de pagamento do cliente',
          'danger'
        );
        return;
      }

      if(data.payment_value > data.spent){
        this.makeToast(
          'Erro',
          'O valor a receber não pode ser maior que o valor do débito',
          'danger'
        );
        return;
      }

      this.$store.dispatch('startLoader');
      this.paymentWallet(data)
      .then((response) => {
        if(response.data.status_code){
          this.makeToast(
            'Sucesso',
            'Pagamento recebido com sucesso',
            'sucesso'
          );
        }
        this.getAll();
        this.hideModal('payment');
      })
      .catch(() => {
        this.makeToast(
          'Erro',
          'Houve um erro Atualizar os dados',
          'danger'
        );
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
  },
};
</script>

<style scoped>

.end {
  display: flex;
  justify-content: flex-end;
}
</style>